import { useEffect, useState } from 'react'

import { Box, Modal, Spinner } from '@fairfashion/design-system'

import { ICompanyProvidersResponseDTO } from '../../sdk/company/company.types'
import { sdk } from '../../services/sdk'
import { TraceabilityTree } from '../TraceabilityTree'
import { useProviderTree } from '../TraceabilityTree/hooks/useProviderTree'

import { ProvidersTreeModalProps } from './providers-tree-modal.types'

export const ProvidersTreeModal = ({
  rootId,
  open,
  onClose,
}: ProvidersTreeModalProps) => {
  const [providers, setProviders] = useState<ICompanyProvidersResponseDTO[]>([])
  const [centerNodeId, setCenterNodeId] = useState<string>('')

  const [expandedPreviousNodes, setExpandedPreviousNodes] = useState<string[]>(
    [],
  )
  const [expandedNextNodes, setExpandedNextNodes] = useState<string[]>([])

  const getProvidersTree = async (
    rootId?: string,
    direction?: 'next' | 'previous',
  ) => {
    const _response = await sdk.company.getProvidersAllTiersProgressive(
      rootId,
      undefined,
      direction,
    )
    return _response
  }

  const fetchProviders = async (rootId?: string) => {
    const providers = await getProvidersTree(rootId)
    setProviders(providers)
  }

  useEffect(() => {
    if (open) {
      fetchProviders(rootId)
    }
  }, [open, rootId])

  const handleNodeExpand = async (
    rootId: string,
    direction: 'next' | 'previous' = 'next',
  ) => {
    setCenterNodeId(rootId)
    const _newProviders = await getProvidersTree(rootId, direction)

    const newProviders = providers.slice()

    _newProviders.forEach((p) => {
      const index = newProviders.findIndex((np) => p.id === np.id)
      if (index !== -1) {
        newProviders[index].nextItems = [
          ...new Set([
            ...(newProviders[index].nextItems || []),
            ...(p.nextItems || []),
          ]),
        ]
      } else {
        newProviders.push(p)

        if (direction === 'next') {
          setExpandedPreviousNodes((_value) => [..._value, p.id])
        } else {
          setExpandedNextNodes((_value) => [..._value, p.id])
        }
      }
    })

    setProviders(newProviders)

    if (direction === 'next') {
      setExpandedNextNodes((_value) => [..._value, rootId])
    } else {
      setExpandedPreviousNodes((_value) => [..._value, rootId])
    }
  }

  const { initialNodes, initialEdges, nodeTypes } = useProviderTree({
    providers: providers as ICompanyProvidersResponseDTO[],
    onNodeExpand: handleNodeExpand,
    expandedPreviousNodes,
    expandedNextNodes,
  })

  if (!open) return null

  return (
    <Modal
      title="Árvore de Rastreamento"
      minHeight="100%"
      minWidth="100%"
      open={open}
      onClose={onClose}
    >
      <Box
        width="100%"
        justifyContent="center"
        alignItems="center"
        height="90vh"
      >
        {!providers ? (
          <Spinner size="60px" />
        ) : (
          <TraceabilityTree
            initialNodes={initialNodes}
            initialEdges={initialEdges}
            nodeTypes={nodeTypes}
            centerNodeId={centerNodeId}
          />
        )}
      </Box>
    </Modal>
  )
}
